<template lang="pug">
section#description.text-center
  h2.i_h2_title {{ description.Title }}
  .divider
  .container
    .row.i_mt_6.i_mt_sm_4
      .col-12.d-flex.flex-column-reverse.flex-lg-row.justify-content-between.align-items-center.align-items-lg-start
        .title.text-left.i_mt_md_4.i_mt_sm_6
          h5 {{ description.ContentTitle }}
          p.i_body_l {{ description.Content }}
        img.bg_default_gray.flex-shrink-0.i_ml_12.i_ml_md_0(
          :src="description.Image"
        )
</template>

<script>
export default {
  name: "Description",
  props: {
    description: Object,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/difference_service/description";
</style>
